import {
  MessageSquare,
  Users,
  Store,
  CreditCard,
} from 'lucide-react';

export interface NavItemConfig {
  to: string;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  badge?: string | number;
  badgeVariant?: 'default' | 'secondary' | 'outline' | 'destructive';
  allowedRoles?: string[];
}

export const navItems: NavItemConfig[] = [
  {
    to: '/conversations',
    label: 'Conversas',
    icon: MessageSquare,
  },
  {
    to: '/customers',
    label: 'Clientes',
    icon: Users,
  },
  {
    to: '/team',
    label: 'Time',
    icon: Users,
    allowedRoles: ['Owner', 'Admin'],
  },
  {
    to: '/integrations',
    label: 'Lojas & Configurações',
    icon: Store,
    allowedRoles: ['Owner', 'Admin'],
  },
  {
    to: '/billing',
    label: 'Faturamento',
    icon: CreditCard,
    allowedRoles: ['Owner'],
  },
];
